/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface OrganizationResponse {
  id: string;
  name: string;
  slug: string;
  logo_url?: string | null;
  plan_tier: string;
  website?: string | null;
  size?: string | null;
  suspension_status?: string | null;
  suspension_reason?: string | null;
  created_at: string;
  updated_at: string;
}
